import React from "react";
import { authPaymentTypes } from "../../../parent/data/auth-payment-types";

export const LoanDetailsPopupButton = ({ selectPaymentType, lastFour }) => {
  return (
    <li>
      <button
        className="f12 mt-0 auth-card-popup-button"
        onClick={() => {
          selectPaymentType(authPaymentTypes.other.LoanDetails, false);
        }}
        data-e2e-id={"loanDetailsButton-" + lastFour}
      >
        Loan Details
      </button>
    </li>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/loan-list/card-children/popup-menu-buttons/loan-details-popup-button.component.js